module.exports = __webpack_public_path__ + "2f8ffb792fbdcd583ca7b204580b417c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/places-to-hang-out-after-school/CoffeeShop1.jpg
// module id = 3367
// module chunks = 0